import type { ToolTestResult, ToolTestRun } from '../../lib/api';
import styles from './ToolTestResult.module.css';

export const MAX_HISTORY = 10;

export interface ToolTestRunRecord extends ToolTestRun {
  id: number;
  at: Date;
}

interface ToolTestHistoryProps {
  runs: ToolTestRunRecord[];
  selectedId: number | null;
  onSelect: (id: number) => void;
}

const outcomeLabel = (result: ToolTestResult): string => {
  if ('error' in result) return result.error;
  if (result.status === 'upstream_http_error') return `HTTP ${result.httpStatus}`;
  return 'success';
};

const badgeClassFor = (result: ToolTestResult): string => {
  if ('error' in result) return styles.errorBadge;
  if (result.status === 'upstream_http_error') return styles.warningBadge;
  return styles.successBadge;
};

export const ToolTestHistory = ({ runs, selectedId, onSelect }: ToolTestHistoryProps) => {
  if (runs.length <= 1) return null;

  return (
    <section className={styles.history}>
      <h4 className={styles.historyTitle}>Recent runs</h4>
      <ul className={styles.historyList}>
        {runs.map(run => (
          <li key={run.id}>
            <button type="button" onClick={() => onSelect(run.id)} aria-pressed={run.id === selectedId}>
              <span className={badgeClassFor(run.result)}>{outcomeLabel(run.result)}</span>
              <time className={styles.historyTime}>{run.at.toLocaleTimeString()}</time>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
